import React, { createContext } from 'react';
interface authPermissionInterface{
    user:{
        email: string;
        isActive: boolean;
        name: string;
        roleID: number;
        roleName: string;
        userId: number;
    },
    permissions:[
        {
            canRead: boolean;
            canView: boolean;
            canWrite: boolean;
            permissionId: number;
            permissionName: string;
            roleId: number;
        }
    ],
    isPermissionLoaded: boolean
}
const AuthorizeContext = createContext<authPermissionInterface | null>(null);
export default AuthorizeContext;